import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import cn from 'classnames'
import { motion } from 'motion/react'

import { primaryShowElement } from 'src/animations/Animations'
import sprite from 'src/assets/sprite.svg'
import { CustomButton } from 'src/components/ui'

import styles from './ConfettiPage.module.scss'
import { ConfettiAnimation } from './components'

interface Props {
  className?: string
}

const ConfettiPage: React.FC<Props> = ({ className }) => {
  const [searchParams] = useSearchParams()
  const typeOfConfetti = searchParams.get('type') // type : 'replenish' | 'send' | 'withdrawal'
  // const withdrawalType = searchParams.get('withdrawal_type') // withdrawalType : 'in_acc' | 'in_ton'
  const numberOfStars = searchParams.get('stars')
  const { username } = useParams()

  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <main className={cn(className, styles.main)}>
      <ConfettiAnimation />

      <motion.svg {...primaryShowElement(1)} className={styles.icon}>
        <use href={`${sprite}#confirmation_white`} />
      </motion.svg>

      <motion.h1 {...primaryShowElement(0.5)}>{t(`confetti.type_of_confetti.${typeOfConfetti}`)}</motion.h1>

      <motion.p {...primaryShowElement(0.5)}>
        {typeOfConfetti !== 'withdrawal'
          ? t(`confetti.description.${typeOfConfetti}`, { numberOfStars, username })
          : t(`confetti.description.withdrawal`, { numberOfStars })}
      </motion.p>

      <div className={styles.buttons}>
        <motion.div {...primaryShowElement(1.5)}>
          <CustomButton onClick={() => navigate('/')} variant='outlined' color='white'>
            {t('confetti.button.on_main')}
          </CustomButton>
        </motion.div>

        {/* <motion.div {...primaryShowElement(2)}>
          <CustomButton onClick={() => navigate('/bottles?mode=my')} variant='contained' color='white'>
            {t('confetti.button.show_banks')}
          </CustomButton>
        </motion.div> */}
      </div>
    </main>
  )
}

export default ConfettiPage
